export function supplierReducer( state = '', action ){
    switch( action.type ){
        case "SET_SUPPLIER": return action.payload
        default: return state
    }
}

export function suppliersReducer( state = '', action ){
    switch( action.type ){
        case "SET_SUPPLIERS": return action.payload
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/products/suppliers/reducers.js